'use client';

import React, { createContext, useContext } from 'react';
import useScheduleYourCallForm from './useScheduleYourCallForm';

export const ScheduleYourCallFormContext = createContext<ReturnType<typeof useScheduleYourCallForm>>(null);

export const useScheduleYourCallFormContext = () => {
  const context = useContext(ScheduleYourCallFormContext);
  if (!context) {
    throw new Error('useScheduleYourCallFormContext must be used within the ScheduleYourCallFormContext');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const ScheduleYourCallFormContextProvider = ({ children }: IProps) => (
  <ScheduleYourCallFormContext.Provider value={ useScheduleYourCallForm() }>
    { children }
  </ScheduleYourCallFormContext.Provider>
);

export default ScheduleYourCallFormContextProvider;
